import config from "../environment/environment-config";
import { IDocumentReducerState } from "../reducers/ttDocumentsReducer";
import { ErrorResponseWrapper } from "@apis/errors/error-response-wrapper";
import { DocumentTypes } from "@apis/model/download-item";
import { Dispatch } from "redux";

export const TOGGLE_DOCUMENT_MODAL = "TOGGLE_DOCUMENT_MODAL";
export const CHECK_DOCUMENT_FAILURE = "CHECK_DOCUMENT_FAILURE";
export const ACCEPT_TERMS_OF_USE = "ACCEPT_TERMS_OF_USE";
export const DOCUMENT_CHECK_BASE_URL = config.documentsConfig.documentCheck;
const ERROR = "ERROR";

export const acceptTermsOfUse = (value: boolean) => ({
  type: ACCEPT_TERMS_OF_USE,
  payload: { value },
});

export const toggleModal = () => ({
  type: TOGGLE_DOCUMENT_MODAL,
});

export const documentCheckFailure = (
  errorResponse: Partial<IDocumentReducerState>
) => ({
  type: CHECK_DOCUMENT_FAILURE,
  payload: { errorResponse },
});

async function fetchDocumentStatus(url: string) {
  const res = await fetch(url, { credentials: "same-origin" });

  if (!res.ok) {
    throw new ErrorResponseWrapper(res);
  }

  return res.json();
}

async function handleError(error: ErrorResponseWrapper, dispatch: Dispatch) {
  const messages = await error.getTTErrorMessages();
  const { message } = messages;
  const errorData = {
    errorInfo: {
      errorMessage: message,
    },
  };
  dispatch(documentCheckFailure(errorData));
}

export function getDocumentStatus(id: number | string, type: DocumentTypes) {
  const url = `${DOCUMENT_CHECK_BASE_URL}/${id}/${type}`;

  return async (dispatch: Dispatch): Promise<boolean> => {
    try {
      const data = await fetchDocumentStatus(url);

      if (data.status === ERROR) {
        dispatch(documentCheckFailure(data));
        return false;
      }

      return true;
    } catch (error) {
      await handleError(error, dispatch);
      return false;
    }
  };
}
